module.exports = __webpack_public_path__ + "img/bullsi_p.fe9a5756.png";